<template>
  <div class="employee-maintenance">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="推送规则" name="first">
        <news ref="newsView" />
      </el-tab-pane>
      <el-tab-pane label="推送日志" name="second"><logView ref="logoView" /></el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import { FindPushDateType } from '../../api/pointsRule';
import news from './component/newsPush/index.vue';
import logView from './component/logView/index.vue';

export default {
  name: 'EmployeeMaintenance',
  components: {
    news,
    logView,
  },
  data() {
    return {
      activeName: 'first',
      breadcrumb: [
        {
          menu_name: '发布管理',
        },
        {
          menu_name: '新员工推送',
        },
      ],
    };
  },
  created() {
    this.getLocalSt();
    this.getTypeList();
  },
  mounted() {
    this.changeHeader(this.activeName === 'first' ? '推送规则' : '推送日志');
  },
  methods: {
    getTypeList() {
      // 获取后端返回推送配置时间，存到Vuex
      FindPushDateType({ id: 1 })
        .then((res) => {
          const data = res?.dateList;
          const userTypeList = [];
          data.forEach((item) => {
            const obj = {
              label: '',
              value: '',
            };
            obj.label = `入职第${item}天`;
            obj.value = item;
            userTypeList.push(obj);
          });
          this.$store.commit('huizhi/user/setTypeList', userTypeList);
        })
        .catch((res) => {
          console.log(res);
        });
    },
    handleClick(tab) {
      if (tab.name === 'first') {
        this.changeHeader('推送规则');
        this.$refs.newsView.getList();
      } else {
        this.changeHeader('推送日志');
        this.$refs.logoView.getList();
      }
      localStorage.setItem('tabsStatus', tab.name);
    },
    getLocalSt() {
      // 通过locaStorage记录tabs的状态
      if (localStorage.getItem('tabsStatus') !== null) {
        this.activeName = localStorage.getItem('tabsStatus');
      }
    },
    changeHeader(name) {
      this.breadcrumb = [
        {
          menu_name: '发布管理',
        },
        {
          menu_name: '新员工推送',
        },
      ];
      this.breadcrumb.push({ menu_name: name });
      this.g_breadcrumb(this.breadcrumb);
    },
  },
};
</script>
<style scoped lang="scss">
@import './index.scss';
</style>
